/* ---------------------------------------------------------------
   HEIDI — Prix sur demande, 06/10/2026.

   Une variante à 0 est une exécution tarifée au cas par cas par le fabricant.
   Côté données elle est déjà bloquée à l'achat (stock suivi, 0, politique DENY) :
   ce script ne protège donc rien, il corrige seulement ce que l'acheteur LIT.

   Sans lui, Ella affiche pour ces variantes :
     - « En rupture de stock » sur le bouton d'ajout au panier ;
     - « ø 800 mm (Sold out) » dans la liste déroulante (chaîne anglaise en dur
       dans `assets/variants.js`, setInputAvailability).
   Les deux laissent croire à une rupture alors que l'article se commande sur devis.

   Le prix lui-même est traité côté serveur dans `snippets/price.liquid` : le bloc
   prix est re-rendu en AJAX à chaque changement de variante, il n'a pas besoin de JS.

   Rien n'est modifié dans les fichiers d'Ella : ce script passe APRÈS eux, sur les
   mêmes événements, et ne touche que les variantes dont le prix vaut 0.
   --------------------------------------------------------------- */
(function () {
  'use strict';

  var CONFIG = window.hsPrixSurDemande || {};
  var LABEL = CONFIG.label || 'Prix sur demande';
  var SEP = ' – ';

  function lireVariantes(conteneur) {
    var script = conteneur.querySelector('script[type="application/json"]');
    if (!script) return null;
    try {
      var data = JSON.parse(script.textContent);
      return Array.isArray(data) ? data : null;
    } catch (e) {
      return null;
    }
  }

  /* Valeurs actuellement choisies dans un sélecteur Ella (listes ou boutons radio). */
  function valeursCourantes(el) {
    var selects = el.querySelectorAll('select');
    if (selects.length) {
      return Array.prototype.map.call(selects, function (sel) { return sel.value; });
    }
    return Array.prototype.map.call(el.querySelectorAll('fieldset'), function (fs) {
      var coche = fs.querySelector('input:checked');
      return coche ? coche.value : null;
    });
  }

  function trouverVariante(data, valeurs) {
    for (var k = 0; k < data.length; k++) {
      var v = data[k];
      if (v.options.every(function (o, j) { return o === valeurs[j]; })) return v;
    }
    return null;
  }

  /* Variantes à 0 de la page, et état du choix courant de chaque sélecteur.
     `invalide` : la combinaison choisie n'existe pas (Ella affiche alors
     « Indisponible », qu'il ne faut pas recouvrir). */
  function variantesSurDemande() {
    var ids = {};
    var selecteurs = [];
    var invalide = false;
    document.querySelectorAll('variant-selects, variant-radios').forEach(function (vs) {
      var data = lireVariantes(vs);
      if (!data) return;
      var aZero = false;
      data.forEach(function (v) {
        if (Number(v.price) === 0) {
          ids[String(v.id)] = true;
          aZero = true;
        }
      });
      if (!aZero) return;
      if (!trouverVariante(data, valeursCourantes(vs))) invalide = true;
      selecteurs.push({ el: vs, data: data });
    });
    return { ids: ids, selecteurs: selecteurs, invalide: invalide };
  }

  /* Formulaire « Me prévenir du retour en stock » : sans objet pour un article sur
     devis, qui n'est pas en rupture. */
  function masquerAlerteStock(form) {
    var vue = form.closest('.productView, .halo-productView, .shopify-section') || document;
    vue.querySelectorAll('.productView-notifyMe, .halo-notifyMe').forEach(function (el) {
      if (window.jQuery) window.jQuery(el).stop(true, true);
      el.style.display = 'none';
    });
  }

  /* Bouton « Au panier » : libellé « Prix sur demande » au lieu de « En rupture de stock ». */
  function boutons(ids, invalide) {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var champ = form.querySelector('[name="id"]');
      if (!champ || !champ.value) return;
      var btn = form.querySelector('[name="add"], [data-btn-addToCart]');
      if (!btn) return;
      if (ids[String(champ.value)] && !invalide) {
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('data-hs-sur-demande', '');
        if (btn.textContent.trim() !== LABEL) btn.textContent = LABEL;
        masquerAlerteStock(form);
      } else if (btn.hasAttribute('data-hs-sur-demande')) {
        /* Retour sur une variante tarifée : Ella a déjà réécrit le libellé et l'état,
           on retire seulement notre marqueur. */
        btn.removeAttribute('data-hs-sur-demande');
      }
    });
  }

  /* Listes déroulantes : « ø 800 mm – Prix sur demande » au lieu de « (Sold out) ». */
  function options(selecteurs) {
    selecteurs.forEach(function (s) {
      var selects = s.el.querySelectorAll('select');
      if (!selects.length) return;
      var courants = Array.prototype.map.call(selects, function (sel) { return sel.value; });

      selects.forEach(function (sel, i) {
        Array.prototype.forEach.call(sel.options, function (opt) {
          var valeur = opt.getAttribute('value') || opt.value;
          var variante = null;
          for (var k = 0; k < s.data.length; k++) {
            var v = s.data[k];
            var ok = v.options.every(function (o, j) {
              return j === i ? o === valeur : o === courants[j];
            });
            if (ok) { variante = v; break; }
          }
          if (!variante) return;
          var attendu = Number(variante.price) === 0 ? valeur + SEP + LABEL : null;
          if (attendu) {
            if (opt.textContent !== attendu) opt.textContent = attendu;
          } else if (opt.textContent.indexOf(SEP + LABEL) !== -1) {
            opt.textContent = valeur;
          }
        });
      });
    });
  }

  /* Page devis : `assets/heidi-quote.js` écrit « quantité × prix » dans chaque ligne,
     soit « CHF 0.00 » pour une variante sur demande. La ligne porte son libellé dans
     `data-hs-sur-demande` (`snippets/hs-quote-line.liquid`) : on le remet par-dessus. */
  function lignesDevis() {
    document.querySelectorAll('[data-hs-quote-line][data-hs-sur-demande]').forEach(function (line) {
      var prix = line.querySelector('[data-hs-line-price]');
      var libelle = line.getAttribute('data-hs-sur-demande');
      if (prix && libelle && prix.textContent !== libelle) prix.textContent = libelle;
    });
  }

  function appliquer() {
    lignesDevis();
    var etat = variantesSurDemande();
    if (!Object.keys(etat.ids).length) return;
    boutons(etat.ids, etat.invalide);
    options(etat.selecteurs);
  }

  /* Les lignes de devis arrivent en AJAX et leurs prix sont réécrits à chaque
     changement de quantité. L'observateur n'est posé QUE sur la page devis, dont
     l'URL vient de la configuration de `snippets/heidi-quote-assets.liquid`. */
  function observerDevis() {
    var cfg;
    try {
      cfg = JSON.parse(document.getElementById('hs-quote-config').textContent);
    } catch (e) {
      return;
    }
    var page = String(cfg.quoteUrl || '').replace(/\/$/, '');
    if (!page || window.location.pathname.replace(/\/$/, '') !== page) return;
    if (document.body.__hsPsd) return;
    document.body.__hsPsd = true;
    new MutationObserver(lignesDevis).observe(document.body, { childList: true, subtree: true, characterData: true });
    lignesDevis();
  }

  /* Ella réécrit bouton et options de façon synchrone dans son propre écouteur
     `change`, puis re-rend le bloc prix en AJAX. On repasse juste après, puis une
     seconde fois pour couvrir la réponse réseau. */
  function planifier() {
    setTimeout(appliquer, 0);
    setTimeout(appliquer, 400);
    setTimeout(appliquer, 1200);
  }

  document.addEventListener('change', planifier);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('variant-radios, variant-selects, [data-quickshop-popup], .quickview')) planifier();
  });
  function demarrer() {
    observerDevis();
    planifier();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
  window.addEventListener('load', planifier);
})();
